import * as React from 'react';
import { Grid, Typography } from '@mui/material';


export default function EtapeErreur() {
	return (
		<>

			<Grid container spacing={3} direction="row" justifyContent="center">

				<Grid item xs={12}>
					<Typography component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2 }}>
						Erreur
					</Typography>
				</Grid>

				<Grid item xs={12} sm={12} md={10} lg={8} xl={6}>
					Une erreur s'est produite ...
				</Grid>

			</Grid>

		</>
	);
}
